module.exports = __webpack_public_path__ + "fonts/lato-black-latin.77b69d1.woff";